import { useEffect, useState } from 'react'
import useCustomerNumber from '../../../../hooks/useCustomerNumber'
import { selectHasDE } from '../../../../redux/customer'
import { getUpcomingAppointments } from '../services'
import { longDateFormat } from '../../../../helpers/date'
import { useAppSelector } from '../../../../redux/store'
import { selectUserTimezone } from '../../../../redux/user'
import { LoadingState } from '../../../../types'
import { UpcomingAppointment } from '../types'

const useDEAppointment = () => {
  const hasDE = useAppSelector(selectHasDE)

  const customerNumber = useCustomerNumber()

  const [upcoming, setUpcoming] = useState<UpcomingAppointment | null>(null)
  const [loading, setLoading] = useState<LoadingState>(LoadingState.NotStarted)
  const [nextAppointment, setNextAppointment] = useState<string>('')

  const timezone = useAppSelector(selectUserTimezone)

  const fetchData = async (customerNumber: string) => {
    try {
      setLoading(LoadingState.Loading)

      const appointment = await getUpcomingAppointments(customerNumber)

      setUpcoming(appointment)
      setLoading(LoadingState.Done)
    } catch (err) {
      console.error('unable to get de appointment', err)
      setLoading(LoadingState.Error)
    }
  }

  useEffect(() => {
    const shouldFetch = customerNumber && hasDE && timezone
      && loading === LoadingState.NotStarted

    if (shouldFetch) {
      fetchData(customerNumber)
    }
  }, [customerNumber, hasDE, timezone, loading])

  useEffect(() => {
    const start = upcoming?.started_at

    if (start && timezone && loading === LoadingState.Done) {
      const next = longDateFormat(start, timezone)
      setNextAppointment(next)
    }
  }, [upcoming, timezone, loading])

  return nextAppointment
}

export default useDEAppointment
